import React, {Component} from 'react';

import Header from "../../components/Header";
import Paragraph from "../../components/Paragraph";
import ContentBlock from "../../components/ContentBlock";
import FooterBlock from "../../components/FooterBlock";

import s from "./About.module.scss";
import FirebaseContext from "../../context/firebaseContext";

class AboutPage extends Component {

    componentDidMount() {
    }

    render() {
        return (
            <>
                <ContentBlock
                    background="steelblue"
                >
                    <Header>
                        ПРО КАРТОЧКИ
                    </Header>
                    <Paragraph>
                        Карточки английского языка - это отличный способ выучить более 1000 новых слов из 30 тем, а вместе с тем повысить уровень английского и стать интересным собеседником. English Student предлагает простой и эффективный способ изучения английского языка. Он базируется на систематическом изучении и интервальном повторении пройденного лексического материала. Первые результаты будут заметны уже через неделю ежедневных занятий.

                        Купить карточки по английскому языку стоит, если ваша цель — спокойно и уверенно разговаривать на английском в различных ситуациях. Убедитесь в эффективности этого метода обучения на собственном опыте!
                    </Paragraph>
                </ContentBlock>
                <FooterBlock
                    cop="Company 2020"
                />
            </>
        );
    }
}
AboutPage.contextType = FirebaseContext;

export default AboutPage;